module.exports = __webpack_public_path__ + "img/icon2.00b56625.svg";